import React from 'react';
import { shareLeagueOnFacebook, shareLeagueOnTwitter } from './../../share';

const TeamShare = (props) => {
    const { trans, LeagueCode, LeagueId, LeagueName, ShareLoad } = props;
    return <div className="si-modal-wrap">
        <div className="si-common-popup si-small-popup si-share-popup">
            <div className="si-popup-body si-flexBox">
                <div className="si-details-wrap">
                    <div className="si-join-code">
                        <span className="si-title">{trans['pick_a_platform_share'] ? trans['pick_a_platform_share'] : "Pick a platform to share"}</span>
                        <div className="si-code-wrp">
                            <span>{}</span>
                        </div>
                    </div>
                    <div className="si-social-share">
                        <div className="si-title">{}</div>
                        <div className="si-share-med">
                            <div className="si-share-item si-fb-share"
                                onClick={(e) => shareLeagueOnFacebook(e, null, null, null, ShareLoad, trans, "team")}>
                                <i className="icon-ucl-facebook" />
                            </div>
                            <div className="si-share-item si-tweet-share"
                                onClick={(e) => shareLeagueOnTwitter(e, null, null, null, ShareLoad, trans, "team")}>
                                <i className="icon-ucl-twitter" />
                            </div>
                        </div>
                    </div>
                </div>
                <i className="si-close icon-ucl-close" onClick={() => props.toHide()} />
            </div>
        </div>
    </div>
};
export default TeamShare;


// WEBPACK FOOTER //
// ./src/components/shareTeam/share-Team.js